export const getAuth = state => state.core.auth
export const getAccessToken = state => state.core.auth.access_token
export const getIsAppInitiated = state => state.core.isAppInitiated
export const getIsApiConnected = state => state.core.isApiConnected
export const getLayout = state => state.core.layout
export const getSetting = (state, field) => state.core.settings[field]
export const getModal = state => state.core.modal
export const getSubModal = state => state.core.submodal